import React, { useRef, useEffect } from "react";
import { Container, Sprite } from "@pixi/react";
import { useSelector } from "react-redux";
import ReelBackController, {
  STATIC_CONFIG,
  STATIC_CONFIG_FEATURE,
  SPINE_CONFIG,
} from "./ReelBackController";
import { Settings } from "../../../settings";
import { safeInit } from "../../../utilities";
import { selectHoldAndWinActive } from "../../../State/selectors";
import * as PIXI from "pixi.js";
import { ASSET_NAME } from "../../../assets";

const ReelBack = ({
  symbolWidth,
  symbolHeight,
  dimensions,
  dividerDimensions,
  renderMode = "static", // New prop: "spine" or "static"
}) => {
  const reelBackControllerRef = useRef(null);
  const containerRef = useRef(null);
  const holdAndWinActive = useSelector(selectHoldAndWinActive);

  useEffect(() => {
    // Only initialize controller for spine mode
    if (
      renderMode === "spine" &&
      containerRef.current &&
      !reelBackControllerRef.current
    ) {
      safeInit(() => {
        reelBackControllerRef.current = new ReelBackController(
          containerRef.current,
          symbolWidth,
          symbolHeight,
          dimensions,
          dividerDimensions
        );
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renderMode]);

  // Handle dimension changes for responsive design (spine mode only)
  useEffect(() => {
    if (renderMode === "spine" && reelBackControllerRef.current) {
      reelBackControllerRef.current.resizeReelBack(
        symbolWidth,
        symbolHeight,
        dimensions,
        dividerDimensions
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [symbolHeight, renderMode]);

  // Calculate dimensions for static sprite with dividers
  const dividerCount = Settings.REEL_COUNT - 1;
  const dividerWidth = dividerDimensions?.width ?? 0; // Default to 0 if not provided
  // Use different config based on Hold and Win state
  const config = holdAndWinActive ? STATIC_CONFIG_FEATURE : STATIC_CONFIG;
  // Width includes dividers and multiplier
  const staticWidth =
    (symbolWidth * Settings.REEL_COUNT + dividerWidth * dividerCount) *
    config.widthMultiplier;
  const staticHeight =
    symbolHeight * Settings.SYMBOLS_VISIBLE * config.heightMultiplier;

  // Get texture for static mode (different texture for base and feature)
  const staticTexture =
    renderMode === "static"
      ? holdAndWinActive
        ? PIXI.Assets.get(ASSET_NAME.reel_frame_back_static_feature)
        : PIXI.Assets.get(ASSET_NAME.reel_frame_back_static)
      : null;

  return (
    <Container
      y={
        renderMode === "spine"
          ? -symbolHeight *
            Settings.SYMBOLS_VISIBLE *
            SPINE_CONFIG.verticalOffset
          : config.verticalOffset
      }
      x={
        renderMode === "spine"
          ? symbolWidth * Settings.REEL_COUNT * SPINE_CONFIG.horizontalOffset
          : config.horizontalOffset
      }
      ref={containerRef}
      name="back_texture"
      zIndex={1}
    >
      {renderMode === "static" && staticTexture && (
        <Sprite
          texture={staticTexture}
          width={staticWidth}
          height={staticHeight}
          zIndex={2}
          anchor={0.5}
        />
      )}
    </Container>
  );
};

export default ReelBack;
